import { makeStyles } from '@material-ui/core';
import salsaLogo from '../../assets/salsa-shield.png';

const useStyles = makeStyles({
  logo: {
    width: 'auto',
    height: 28,
    objectFit: 'contain',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      filter: 'drop-shadow(0 0 6px rgba(184, 32, 37, 0.4))',
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fallback: {
    color: '#B82025',
    fontWeight: 700,
    fontSize: '18px',
    letterSpacing: '0.5px',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img
        src={salsaLogo}
        alt="Salsa"
        className={classes.logo}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
          if (target.parentElement) {
            target.parentElement.innerHTML = '<span class="' + classes.fallback + '">S</span>';
          }
        }}
      />
    </div>
  );
};

export default LogoIcon;
